import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router';

import LoginCallbackPage from '@/pages/LoginCallbackPage.vue';
import routePaths from '@/router/routes.json';

const loginCallbackPageRoutes: RouteRecordRaw[] = Object.entries(routePaths).map(
  ([locale, routeItem]) => ({
    path: `/${(routeItem as any).favourites.path}/login-callback`,
    name: `loginCallbackPage-${locale}`,
    component: LoginCallbackPage,
    meta: {
      locale,
      getLanguageSwitchLink(_route: RouteLocationNormalized, language: HgSupportedLanguage) {
        return {
          name: `loginCallbackPage-${language}`,
        };
      },
      viewName: 'LoginCallback Page',
    },
  }),
);

export default loginCallbackPageRoutes;
